// extracted by mini-css-extract-plugin
module.exports = {"item":"ParamItem_item__-WAEo","head":"ParamItem_head__3-jx7","controlls":"ParamItem_controlls__3SfX3"};